import { createVeriffFrame } from '@veriff/incontext-sdk'
import React, { useEffect } from 'react'
import { injectIntl } from 'react-intl'

import TierTwoError from '../TierTwoError'
import { PropsType } from '.'

type VeriffMessageType = 'CANCELED' | 'FINISHED'

const Veriff = ({ hideModal, syncVeriff, veriffMetadata, veriffMetadataError }: PropsType) => {
  useEffect(() => {
    if (veriffMetadata) {
      createVeriffFrame({
        onEvent: (event: VeriffMessageType) => {
          if (event === 'FINISHED') {
            syncVeriff()
          }
          if (event === 'CANCELED') {
            hideModal()
          }
        },
        url: veriffMetadata.data.url
      })
    }
  }, [veriffMetadata])

  return veriffMetadata ? null : veriffMetadataError ? (
    <TierTwoError {...veriffMetadataError} />
  ) : null
}

// @ts-ignore FIXME Typing problem with redux forms and react intl
export default injectIntl(Veriff)
